import { FC } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { ProductCarouselProps, Styled } from '.';
import { ProductTile } from '..';
import { Product } from 'types';
import { useRouter } from 'next/router';
import { buildCarouselPlaceholderData } from './ProductCarousel.helper';

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 2560 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 2560, min: 1200 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1200, min: 900 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 900, min: 600 },
    items: 2,
  },
  smallMobile: {
    breakpoint: { max: 600, min: 0 },
    items: 1,
  },
};
const ProductCarousel: FC<ProductCarouselProps> = ({
  title,
  products,
  isLoading,
  isError,
  doctorPromotionList,
  dsoPromotionList,
  isIMSCarousel = false,
  imsNavigationURL = '#',
  imsNavigationText = '',
}) => {
  const router = useRouter();

  if (!isLoading && products.length === 0) {
    return <></>;
  }

  const displayProducts =
    isLoading && products.length === 0
      ? buildCarouselPlaceholderData()
      : products;

  return (
    <Styled.ProductCarouselContainer>
      <Styled.ProductListHeader>
        <Styled.ProductListHeaderTitle
          $isIMSCarousel={isIMSCarousel}
          onClick={() => (isIMSCarousel ? router.push(imsNavigationURL) : null)}
        >
          {title}
        </Styled.ProductListHeaderTitle>
      </Styled.ProductListHeader>

      <Styled.ProductsContainer>
        <Carousel
          responsive={responsive}
          autoPlay={false}
          shouldResetAutoplay={false}
        >
          {displayProducts.map((product: Product) => {
            return (
              <ProductTile
                key={product.id}
                product={product}
                isLoading={isLoading}
                isError={isError}
                doctorPromotionList={doctorPromotionList}
                dsoPromotionList={dsoPromotionList}
              />
            );
          })}
          {isIMSCarousel ? (
            <Styled.IMSNavigationTile
              onClick={() => router.push(imsNavigationURL)}
            >
              {imsNavigationText} <br /> <Styled.IMSNavigationArrow />
            </Styled.IMSNavigationTile>
          ) : null}
        </Carousel>
      </Styled.ProductsContainer>
    </Styled.ProductCarouselContainer>
  );
};

export default ProductCarousel;
